const formatDate = function(date) {
  return (
    date &&
    new Date(new Date(date) - new Date(date).getTimezoneOffset() * 60000)
      .toISOString()
      .substring(0, 10)
  )
}

const formatDateTime = function(date) {
  if (date) {
    let result = new Date(
      new Date(date) - new Date(date).getTimezoneOffset() * 60000,
    ).toISOString()
    result = result.split('T')
    return result[0] + ' ' + result[1].substring(0, 8)
  }
  return null
}

const dateFromCalendar = function(calendarDate) {
  let newDate = null
  if (calendarDate) {
    newDate = new Date(calendarDate)
    newDate = new Date(
      Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate()),
    )
  }
  return newDate
}

export { formatDate, formatDateTime, dateFromCalendar }
